<div class="container-fluid p-4" role="main" aria-label="Campaign Performance Dashboard">
  <!-- <app-loader *ngIf="loading" [fullPage]="true" [message]="'Loading performance data...'" [size]="'large'" aria-live="polite"></app-loader> -->

  <!-- <div class="content" [ngClass]="{'loading-content': loading}" style="position: relative; z-index: 1;"> -->
  <div class="content" [ngClass]="{'loading-content': hasAnyLoadingState()}" style="position: relative; z-index: 1;">    
    <!-- Campaign Filter -->
    <app-campaign-filter
      [showAllCampaignsOption]="true"
      [CampaignType]="1"
      (performanceRequested)="onCampaignSelected($event)">
    </app-campaign-filter>
    
    <!-- Campaign Summary Card (always visible - matches article/journal pattern) -->
    <div class="card metrics-card mb-4">
      <div class="card-body">
        <h5 class="summary-title mb-3">
          Campaign Summary
          <span *ngIf="selectedCampaign" class="campaign-name-badge ms-2" 
                [title]="selectedCampaign">
            {{ selectedCampaign }}
          </span>
        </h5>
        
        <app-loader *ngIf="!selectedCampaign || loadingStates['summary']" [showMessage]="false" [size]="'small'"></app-loader>
        
        <div *ngIf="selectedCampaign && !loadingStates['summary']" class="metrics-row">
          <!-- Campaign Count -->
          <div class="metric-item">
            <div class="metric-color" style="background-color: #4169E1"></div>
            <div class="metric-info">
              <div class="metric-name">Total Campaigns</div>
              <div class="metric-value">{{ campaignSummary.campaignCount | number }}</div>
            </div>
          </div>
          
          <!-- Emails Sent -->
          <div class="metric-item">
            <div class="metric-color" style="background-color: #9C27B0"></div>
            <div class="metric-info">
              <div class="metric-name">Total Emails Sent</div>
              <div class="metric-value">{{ campaignSummary.emailsSent | number }}</div>
            </div>
          </div>
          
          <!-- Average Open Rate -->
          <div class="metric-item">
            <div class="metric-color" style="background-color: #2196F3"></div>
            <div class="metric-info">
              <div class="metric-name">Avg. Open Rate</div>
              <div class="metric-value">{{ campaignSummary.avgOpenRate | number:'1.2-2' }}%</div>
            </div>
          </div>
          
          <!-- Average CTR -->
          <div class="metric-item">
            <div class="metric-color" style="background-color: #FF5722"></div>
            <div class="metric-info">
              <div class="metric-name">Avg. CTR</div>
              <div class="metric-value">{{ campaignSummary.avgCTR | number:'1.2-2' }}%</div>
            </div>
          </div>
          
          <div class="metric-item">
            <div class="metric-color" style="background-color: #286a7e"></div>
            <div class="metric-info">
              <div class="metric-name">Avg. CTOR</div>
              <div class="metric-value">{{ campaignSummary.avgCTOR | number:'1.2-2' }}%</div>
            </div>
          </div>
          
          <div class="metric-item">
            <div class="metric-color" style="background-color: #df890a"></div>
            <div class="metric-info">
              <div class="metric-name">Total Bounced</div>
              <div class="metric-value">{{ campaignSummary.totalBounced | number }}</div>
            </div>
          </div>
          
          <div class="metric-item">
            <div class="metric-color" style="background-color: #9e1b04"></div>
            <div class="metric-info">
              <div class="metric-name">Total Unsubscribes</div>
              <div class="metric-value">{{ campaignSummary.totalUnSubscribes | number }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Analytics Charts Section (always visible - matches article/journal pattern) -->
    <div class="row g-4">
      <!-- Row 1: Campaign Delivery Metrics and Campaign Performance Rates (Only show for specific campaigns) -->
      <div *ngIf="selectedCampaign && selectedCampaign !== 'All Campaigns' && performanceData && performanceData.length > 0" class="col-12 col-lg-6">
        <div class="chart-container" role="region" aria-label="Campaign Performance Metrics Chart">
          <app-line-area-chart 
            [data]="performanceData" 
            [title]="'Campaign Delivery Metrics'"
            [series]="performanceSeries"
            [xKey]="'campaign'"
            [legendInfo]="performanceLegendInfo" 
            [fileName]="'campaign-performance.png'" 
            [defaultType]="'bar'" 
            [showToggle]="false" 
            [lineOnly]="false" 
            [isHorizontalBarChart]="true"
            height="400px"
            [powerBiUrl]="'https://app.powerbi.com/groups/932e7989-a8b9-4046-b5ec-65f5ab7fdff8/list?ctid=dc10e84a-5061-4946-8279-9dd51547c7e9&experience=power-bi'">
          </app-line-area-chart>
        </div>
      </div>
      
      <div *ngIf="selectedCampaign && selectedCampaign !== 'All Campaigns' && performanceRateData && performanceRateData.length > 0" class="col-12 col-lg-6">
        <div class="chart-container" role="region" aria-label="Campaign Performance Rates Chart">
          <app-line-area-chart 
            [data]="performanceRateData" 
            [title]="'Campaign Performance Rates (%)'"
            [series]="performanceRateSeries"
            [xKey]="'campaign'"
            [legendInfo]="performanceRateLegendInfo" 
            [fileName]="'campaign-performance-rates.png'" 
            [defaultType]="'bar'" 
            [showToggle]="false" 
            [lineOnly]="false" 
            [isHorizontalBarChart]="true"
            height="400px"
            [powerBiUrl]="'https://app.powerbi.com/groups/932e7989-a8b9-4046-b5ec-65f5ab7fdff8/list?ctid=dc10e84a-5061-4946-8279-9dd51547c7e9&experience=power-bi'">
          </app-line-area-chart>
        </div>
      </div>

      <!-- Analytics Charts - Always show 4 chart containers (matches article/journal pattern) -->
      <!-- Row 1: Conversion Funnel and Email Engagement -->
      <div class="col-12 col-lg-6">
        <div class="chart-container" role="region" aria-label="Email Campaign Metrics Chart">
          <app-line-area-chart 
            [title]="'Conversion Funnel'" 
            [data]="emailMetricsData" 
            [series]="emailMetricsSeries" 
            [legendInfo]="emailMetricsLegendInfo" 
            [fileName]="'email-metrics.png'" 
            [isHorizontalBarChart]="true"
            [defaultType]="'bar'" 
            [showToggle]="false" 
            [lineOnly]="false"                                                 
            height="400px" 
            [loading]="!selectedCampaign || loadingStates['emailMetrics']"
            [powerBiUrl]="'https://app.powerbi.com/groups/932e7989-a8b9-4046-b5ec-65f5ab7fdff8/list?experience=power-bi'">
          </app-line-area-chart>
        </div>
      </div>
      
      <div class="col-12 col-lg-6">
        <div class="chart-container" role="region" aria-label="Email Effectiveness Metrics Chart">
          <app-line-area-chart 
            [title]="'Email Engagement'" 
            [data]="emailEffectivenessData" 
            [series]="emailEffectivenessSeries" 
            [legendInfo]="emailEffectivenessLegendInfo" 
            [fileName]="'email-effectiveness.png'" 
            [defaultType]="'line'" 
            [showToggle]="true" 
            [lineOnly]="false" 
            height="400px" 
            [loading]="!selectedCampaign || loadingStates['emailEffectiveness']"
            [powerBiUrl]="'https://app.powerbi.com/groups/932e7989-a8b9-4046-b5ec-65f5ab7fdff8/list?experience=power-bi'">
          </app-line-area-chart>
        </div>
      </div>

      <!-- Row 2: Email Performance (%) and Email Attrition Rates (%) -->
      <div class="col-12 col-lg-6">
        <div class="chart-container" role="region" aria-label="Email Readership Rates Chart">
          <app-line-area-chart 
            [title]="'Email Performance (%)'" 
            [data]="emailReadershipRateData" 
            [series]="emailReadershipRateSeries" 
            [legendInfo]="emailReadershipRateLegendInfo" 
            [fileName]="'email-readership-rates.png'" 
            [defaultType]="'line'" 
            [showToggle]="true" 
            [lineOnly]="false" 
            height="400px" 
            [loading]="!selectedCampaign || loadingStates['emailReadershipRate']"
            [powerBiUrl]="'https://app.powerbi.com/groups/932e7989-a8b9-4046-b5ec-65f5ab7fdff8/list?experience=power-bi'">
          </app-line-area-chart>
        </div>
      </div>

      <div class="col-12 col-lg-6">
        <div class="chart-container" role="region" aria-label="Email Rejection Rates Chart">
          <app-line-area-chart 
            [title]="'Email Attrition Rates (%)'" 
            [data]="emailRejectionRateData" 
            [series]="emailRejectionRateSeries" 
            [legendInfo]="emailRejectionRateLegendInfo" 
            [fileName]="'email-rejection-rates.png'" 
            [defaultType]="'line'" 
            [showToggle]="true" 
            [lineOnly]="false" 
            height="400px" 
            [loading]="!selectedCampaign || loadingStates['emailRejectionRate']"
            [powerBiUrl]="'https://app.powerbi.com/groups/932e7989-a8b9-4046-b5ec-65f5ab7fdff8/list?experience=power-bi'">
          </app-line-area-chart>
        </div>
      </div>
    </div>
  </div>
</div> 